import baseService from "../BaseService";
import mixinsMessage from "@/mixins/message";
import QhAtvExtraLinha from "@/model/qh/QhAtvExtraLinha";
import QhAtvExtraFuncionario from "@/model/qh/QhAtvExtraFuncionario";
export default {
  listarPorPlano(idPlano) {
    return baseService
      .get("/api/qh-atv-extras", { params: { idPlano: idPlano } })
      .then(response => {
        if (response && response.data) {
          return response.data.map(d => new QhAtvExtraLinha(d));
        }
        return [];
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar listar atividades extras", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  buscarPorId(idAtividade) {
    return baseService
      .get("/api/qh-atv-extras/" + idAtividade)
      .then(response => {
        if (response && response.data) {
          return new QhAtvExtraLinha(response.data);
        }
        return null;
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar carregar atividade", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  salvar(atividade) {
    if (atividade.id) {
      return baseService
        .put("/api/qh-atv-extras/" + atividade.id, atividade)
        .then(response => {
          mixinsMessage.methods.success(response.data);
          return response.data;
        })
        .catch(function(error) {
          mixinsMessage.methods.error("Erro ao tentar atualizar atividade", error);
          // eslint-disable-next-line no-console
          console.error(error);
        });
    }
    return baseService
      .post("/api/qh-atv-extras", atividade)
      .then(response => {
        mixinsMessage.methods.success(response.data);
        return response.data;
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar cadastrar atividade", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  excluir(atividade) {
    return baseService
      .delete("/api/qh-atv-extras/" + atividade.id)
      .then(response => {
        mixinsMessage.methods.success(response.data);
        return response.data;
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar excluir atividade", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  listarFuncionariosElegiveis(idPlano, idAtividade) {
    return baseService
      .get("/api/qh-atv-extras/funcionarios-elegiveis", {
        params: { idPlano: idPlano, idAtividade: idAtividade || null }
      })
      .then(response => {
        if (response && response.data) {
          return response.data.map(d => new QhAtvExtraFuncionario(d));
        }
        return [];
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar listar funcionários", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  listarParticipantes(idAtividade) {
    return baseService
      .get("/api/qh-atv-extras/" + idAtividade + "/participantes")
      .then(response => {
        if (response && response.data) {
          return response.data.map(d => new QhAtvExtraFuncionario(d));
        }
        return [];
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar listar participantes", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  }
};
